// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".voting-vote-section__wrapper[data-v-77ed410d]{background:#0c0a10}.voting-vote-section__wrapper .voting-vote-section__container[data-v-77ed410d]{max-width:1440px;padding:64px 112px 0}@media (max-width:1199px){.voting-vote-section__wrapper .voting-vote-section__container[data-v-77ed410d]{padding:64px 64px 0}}@media (max-width:767px){.voting-vote-section__wrapper .voting-vote-section__container[data-v-77ed410d]{padding:32px 16px 0}}", ""]);
// Exports
module.exports = exports;
